"use strict";
/** state: Final **/
/** family: Modal **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var ModalHeader_1 = require("../ModalHeader");
var ModalTitle_1 = require("../ModalTitle");
var utils_1 = require("../utils");
var CLASS_NAME = 'i-modal';
var ModalSize;
(function (ModalSize) {
    ModalSize["ExtraLarge"] = "xl";
    ModalSize["Large"] = "lg";
    ModalSize["Medium"] = "md";
    ModalSize["Small"] = "sm";
    ModalSize["ExtraSmall"] = "xs";
})(ModalSize = exports.ModalSize || (exports.ModalSize = {}));
/**
 * Modals are used to show additional information or to allow users to perform secondary tasks without leaving their normal workflow.
 *
 * Also see {{Slideout}}.
 */
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Modal.prototype.componentDidMount = function () {
        if (this.props.show && !document.body.style.overflow) {
            document.body.style.overflow = 'hidden';
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        if (document.body.style.overflow) {
            document.body.style.overflow = '';
            document.body.style.overflow = null;
        }
    };
    Modal.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.props.show !== nextProps.show) {
            if (nextProps.show && !document.body.style.overflow) {
                document.body.style.overflow = 'hidden';
            }
            else if (!nextProps.show && document.body.style.overflow) {
                document.body.style.overflow = '';
                document.body.style.overflow = null;
            }
        }
    };
    Modal.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, dialogClassName = _b.dialogClassName, disableFocusLock = _b.disableFocusLock, fixedFooter = _b.fixedFooter, onHide = _b.onHide, size = _b.size, restProps = __rest(_b, ["children", "className", "dialogClassName", "disableFocusLock", "fixedFooter", "onHide", "size"]);
        var classes = classNames(CLASS_NAME, className, {
            show: this.props.show,
        });
        // The ModalHeader wants an onHide property for the close button
        // We supply it here, because the react implementation uses context and we want to avoid that
        var renderChildren = React.Children.map(children, function (child) {
            // Set onHide for the ModalHeader
            if (utils_1.isType(child, ModalHeader_1.ModalHeader)) {
                return React.cloneElement(child, {
                    onHide: onHide,
                });
            }
            return child;
        });
        return (React.createElement("div", { className: classNames({ 'modal-open': this.props.show }) },
            React.createElement(react_bootstrap_1.Modal, __assign({ backdropClassName: classNames({
                    show: this.props.show,
                }), className: classes, container: this, dialogClassName: classNames(dialogClassName, (_a = {},
                    _a[CLASS_NAME + "--fixed-footer"] = fixedFooter,
                    _a[CLASS_NAME + "--" + size] = !!size,
                    _a)), enforceFocus: !disableFocusLock, autoFocus: true, onHide: onHide }, restProps), renderChildren)));
    };
    Modal.Body = react_bootstrap_1.ModalBody;
    Modal.Footer = react_bootstrap_1.ModalFooter;
    Modal.Header = ModalHeader_1.ModalHeader;
    Modal.Subtitle = ModalTitle_1.ModalSubtitle;
    Modal.Size = ModalSize;
    Modal.Title = ModalTitle_1.ModalTitle;
    return Modal;
}(React.Component));
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map